import { connect } from "react-redux";
import ViewCad from "../../../config/view";
import { ConfigPainelChamadaViewProps, mapDispatchToConfigPainelChamadaProps, mapStateToConfigPainelChamadaProps } from "../confpc.controller";
import { ConfigPainelChamada } from "../confpc.model";
import { useEffect } from "react";


function ConfigPainelChamadaCadastro(props: ConfigPainelChamadaViewProps) {
    const { configPainelChamadaActions,configPainelChamadaState } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status, rows } = configPainelChamadaState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = configPainelChamadaActions

    useEffect(()=>{
        get("@config")
    },[])

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: ConfigPainelChamada) => {
        deletar(row);
        setShowDialogExluir(false);
    }

    const formValidate = (values: ConfigPainelChamada) => {
        const errors: any = {}


        return errors
    }

    const handleUpdate = (value: ConfigPainelChamada) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Configuração do painel de chamada",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: rows.length === 0,
            title: "Adicionar Configuração",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => {},
        contentForm: [
            { fieldName: "id_video_youtube", label: "ID Video Youtube", type: "text", key: "descricao", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true },
        ],
    })

    return viewCad.render()
}

export default connect(mapStateToConfigPainelChamadaProps,mapDispatchToConfigPainelChamadaProps)(ConfigPainelChamadaCadastro)

